import { render, staticRenderFns } from "./LContent.vue?vue&type=template&id=18273bcf&scoped=true"
import script from "./LContent.vue?vue&type=script&lang=js"
export * from "./LContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18273bcf",
  null
  
)

export default component.exports